import http from "../../baseUrl/httpcommonGroup";

const allUserGroups = (id) => {
  
  return http.get(`/groups/allUserOfGroup/${id}`);
};

const createGroups = (name, description, userId, imageName) => {
  
  return http.post("/groups/create", {
    name,
    description,
    userId,
    imageName,
  });
};

const deleteGroups = (id) => {
  return http.delete(`/groups/${id}`);
};

const deleteUserInGroups = (data) => {
  return http.delete(`groups/${data.gruop}/removeUser?userId=${data.id}`);
};

const updateGroup = (data) => {
  
  return http.put(`/groups/update/${data.groupId}`, data);
};

const uploadGroupImage = (data) => {
 console.log("uploadGroupImage data",data)
  return http.post(`groups/upload/image`, data,{
    headers: {
      'Content-Type': 'multipart/form-data',
  }});
};

const nonRecipients = (data) => {
  return http.get(`api/users/${data.user}/non-recipients/${data.groupId}`);
};

const addUserInGruop = (payLoad) => {
  return http.post(`groups/${payLoad.gruop}/addUsers`,payLoad.data);
};

const GroupDetail = (payLoad) => {
   return http.get(`groups/${payLoad.id}?userId=${payLoad.userId}`);
 };

const GroupService = {
  allUserGroups,
  createGroups,
  deleteGroups,
  updateGroup,
  uploadGroupImage,
  nonRecipients,
  deleteUserInGroups,
  addUserInGruop,
  GroupDetail
};

export default GroupService;
